import React from 'react'
import { TWITTER_ACCOUNTS } from '../../utils/constants'

export const buildSocialNetworkUrl = ({ name, url }, location, site = 'us', description = '', media = '') => {
  const encodedTitle = encodeURIComponent(description)
  const encodedMedia = encodeURIComponent(media)
  switch (name) {
    case 'facebook':
    case 'douban':
      return `${url}${location}`
    case 'twitter':
      return `${url}${encodedTitle}&url=${location}&via=${TWITTER_ACCOUNTS[site]}`
    case 'pinterest':
      return `${url}${encodeURIComponent(location)}&media=${encodedMedia}&description=${encodedTitle}`
    case 'mail':
      return `${url}${encodedTitle}&body=${location}`
    case 'weibo':
      return `${url}${location}&type=3&pic=${encodedMedia}&title=${encodedTitle}`
    case 'qq':
      return `${url}${location}&title=${encodedTitle}&pics=${encodedMedia}`
    default:
      return location
  }
}

export const renderSocialNetwork = (index, network, site, project, media, galleryURL) => {
  const builtUrl = buildSocialNetworkUrl(network, galleryURL, site, project.title, media)

  const linkProps = network.name === 'wechat' ? { 'data-url': project.url } : { href: builtUrl }
  return (
    <li key={network.name + index} className='afd-share__social'>
      <a
        target='_blank'
        rel='noopener noreferrer'
        data-social={network.name}
        aria-label={network.name}
        {...linkProps}
      >
        <div className='afd-share__button'>
          <i className={`afd-social-icon afd-social-icon--${network.name}`} />
        </div>
        <div className='afd-share__name'>{network.label}</div>
      </a>
    </li>
  )
}

export const buildNimrodGalleryUrl = image => {
  if (!image) return

  const { slug, parent } = image
  const { origin, pathname, search } = new URL(parent.url)
  return `${origin}${pathname}/${slug}${search}`
}

export const OpenNativeShareMobile = shareData => {
  if (shareData.length) return
  const { title, url } = shareData

  try {
    navigator.share({
      title: title,
      url: url
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
}

export const getGalleryFormattedUrl = url => {
  const urlObject = new URL(url)
  const params = urlObject.search
  const cleanUrl = params && urlObject.href.replace(params, '/')
  return { url: cleanUrl || url, params }
}
